import { Dimensions, Platform } from 'react-native'
import theme from './theme'
const { width } = Dimensions.get('window')
const isWeb = Platform.OS === 'web'
//Rutas de los stores
export const routeStores = {
    appStoreUrl: 'https://apps.apple.com/ar/app/somos-protagonistas-2-0/id6467438150',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.oravian.one.sp',
}
export const SplashTheme = {
    splashGifWidth: '50%',
    splashGifHeight: width / 2,
}

//Colores Login
export const LoginTheme = {
    splashBackgroundColor: '#FFFFFE',
    splashGradientStartColor: 'white',
    splashGradientEndColor: 'white',
    loginGradientStartColor: 'white',
    loginGradientEndColor: 'white',
    splashTextColor: theme.colors.textSecondary,
    loginBackgroundColor: 'white',
    loginTextcolor: theme.colors.textPrimary,
    mainButtonBackgroundColor: theme.colors.colorPrimary,
    mainButtonTextColor: 'white',
    backButtonBackgroundColor: 'white',
    backButtonTextColor: theme.colors.colorPrimary,
    noteOffTextColor: theme.colors.textSecondary,
    errorMessageTextColor: theme.colors.error,
    timer: 4100,
    clientLogoMarginBottom: 0,
    clientLogoWidth: 148,
    clientLogoHeight: 128,
}

// Colores del Progress.Bar
export const colorUnfilled = theme.colors.textPrimary
export const colorFilled = theme.colors.colorPrimary
export const colorFilledBis = 'white'

// Colores de Filtros
export const colorFilterSelected = theme.colors.colorPrimary
export const colorFilterUnselected = theme.colors.mediumGray
export const colorFilterUnselectedPS = 'white'
export const colorFilterIconSelected = 'white'
export const colorFilterIconUnselected = theme.colors.colorPrimary
export const colorFilterTextSelected = 'white'
export const colorFilterTextUnselected = theme.colors.textPrimary

// AppBar
export const AppBarTheme = {
    navImage: require('./assets/client.png'),
    navImageWidth: 120,
    navImageHeight: 35,
    navImageTransform: [{ scale: 1 }],
}
export const AppGradientTheme = {
    mainGradientStart: 'white',
    mainGradientEnd: 'white',
    secondaryGradientStart: theme.colors.linearGradientStart,
    secondaryGradientEnd: theme.colors.linearGradientEnd,
}
//HeaderPost
export const HeaderPostTheme = {
    clientDefaultImage: require('./assets/iconWall.png'),
    clientNameDefaultText: 'Somos Protagonistas',
}
export const PostTagsTheme = {
    tagSelectedColor: theme.colors.colorPrimary,
    tagSelectedTextColor: 'white',
    tagUnselectedColor: 'white',
    tagUnselectedTextColor: colorFilterTextUnselected,
}
//Color de texto para botones/encuestas/evaluaciones/etc...
export const colorText = 'white'
export const colorButtonTextEnabled = 'white'
export const colorButtonTextDisabled = theme.colors.textSecondary
export const colorIcon = 'white'

//Background para Podcast
export const podcastBackground = 'https://resources-one.s3.us-east-2.amazonaws.com/salesbook/contenido/iconos/podcastbackground.png'

// Trivia
export const triviaMainColor = theme.colors.colorPrimary
export const triviaMainColorOpacity = triviaMainColor + '14' //Opacidad 20%
const triviaSecondaryColor = theme.colors.colorSecondary
const triviaColorTitles = 'white'
const triviaRankingPositionColor = triviaMainColor

export const TriviaTheme = {
    tabsSelectedColor: !isWeb ? triviaSecondaryColor : triviaMainColor + '33', //Opacidad 20%
    tabsUnselectedColor: !isWeb ? triviaMainColor : triviaMainColor + '14', //Opacidad 8%
    triviaGradient: !isWeb ? [theme.colors.linearGradientStart, theme.colors.linearGradientEnd] : ['#ffffff', '#ffffff'],
    filledBlankTextColor: theme.colors.textPrimary,
    filledBlankSpaceBorderColor: !isWeb ? 'white' : triviaMainColor,
    triviaBackgroundColor: triviaMainColor,
    txtTriviaColorTitles: !isWeb ? triviaColorTitles : triviaMainColor,
    triviaColorTextFillingBlank: !isWeb ? '#1C98F0' : triviaSecondaryColor,
    triviaTimerColor: !isWeb ? triviaColorTitles : triviaMainColor,
    triviaTimerAssetColor: !isWeb ? triviaColorTitles : triviaMainColor,
    triviaTimerBorderColor: !isWeb ? triviaColorTitles : triviaMainColor,
    podiumUserTextcolor: !isWeb ? 'white' : theme.colors.textPrimary,
    podiumUserPointsTextcolor: !isWeb ? triviaMainColor : triviaMainColor,
    rankingPositionTextColor: triviaRankingPositionColor,
    rankingUserTextColor: theme.colors.textPrimary,
    rankingPointsBorderColor: triviaRankingPositionColor,
    triviaCardTextColor: !isWeb ? 'white' : triviaMainColor,
    triviaGameNextButtonBackgroundColor: triviaSecondaryColor,
    timeOutGradient: !isWeb ? ['#DA291C', '#17141d'] : ['#FFCCC8', '#ffffff'],
    finishedGradient: !isWeb ? ['#72DC8A', '#008755'] : [triviaMainColorOpacity, '#C4FFCE'],
    imageSelectedIconColor: triviaMainColor,
    imageCorrectIconColor: 'green',
    imageIncorrectIconColor: 'red',
    imageCorrectNotSelectedIconColor: 'green',
}

//RoundedTabs
export const RoundedTabsTheme = {
    selectedTextColor: !isWeb ? 'white' : triviaMainColor,
    unselectedTextColor: !isWeb ? 'white' : theme.colors.textPrimary,
}

export const HighLightColors = {
    correctBackgorundColor: 'green',
    correctBorderColor: 'green',
    correctTextColor: 'white',
    incorrectBackgorundColor: 'red',
    incorrectBorderColor: 'red',
    incorrectTextColor: 'white',
}
export const StepperColors = {
    previousStepColor: theme.colors.colorPrimary,
    currentStepColor: theme.colors.colorTertiary,
    nextStepColor: !isWeb ? 'white' : theme.colors.mediumGray,
}

//Gamification
export const GamificationTheme = {
    userImageBorderColor: 'white',
    stepPointsTextColor: 'white',
    currentUserLevelTextColor: 'black',
    stepFillColor: 'white',
    stepUnfillColor: theme.colors.darkGray,
    indicatorDefaultBorderColor: 'white',
    indicatorDefaultBackgroundColor: theme.colors.colorPrimary,
    gameLockedBorderColor: '#8F9BDA',
    gameLockedBackgroundColor: 'transparent',
    gameLockedTextColor: 'white',
    gameCompleteTextColor: theme.colors.colorSecondary,
    gamePendingGradientBackgroundColor: theme.colors.alert,
    gamePendingLevelTextColor: theme.colors.textPrimary,
    gamePendingPointsTextColor: theme.colors.textSecondary,
    dotBlockedBorderColor: theme.colors.darkGray,
    dotBloquedIconColor: 'white',
    dotCompleteBackgroundColor: theme.colors.gamificationDotApprovedColor,
    dotCompleteIconColor: 'white',
}
//Gamification DefaultBackgroundGradient
export const GamificationDefaultBackgroundGradient = [theme.colors.colorPrimary, theme.colors.colorSecondary, theme.colors.colorTertiary]

// Gamification Points Gradients
export const pointsGradientEnabled = /** @type {const} */ (['#70C783', '#677EF100'])
export const pointsGradientDisabled = /** @type {const} */ (['#645FF9', '#645FF900'])
export const pointsGradientCurrent = /** @type {const} */ (['#ffffff', '#ffffff80', '#ffffff00'])

// Gamification JackpotButton
export const JackPotGradient = /** @type {const} */ (['#4539EF', '#D93633'])

export const GamificationGameTheme = {
    imageSelectedIconColor: theme.colors.colorPrimary,
    imageCorrectIconColor: 'green',
    imageIncorrectIconColor: 'red',
    imageCorrectNotSelectedIconColor: 'green',
    fillBlanksTextColor: theme.colors.alert,
    fillBlanksOptionUnselectedBackground: 'white',
    fillBlanksOptionBackground: theme.colors.colorPrimary,
    fillBlanksSelectedText: 'white',
    feedBackTitle: '#FFF736',
    interModalButtonBackground: theme.colors.colorPrimary,
    interModalButtonTextColor: 'white',
}
export const GamificationFinishTheme = {
    exitButtonTextColorAp: 'white',
    exitButtonTextColorDis: 'white',
}
export const GamificationRouletteTheme = {
    playButtonTextColor: '#1B1B2B',
    gradientTextColors: /** @type {const} */ (['#FFFFFF', '#FFFCCB']),
}
export const RankingTheme = {
    tabsSelectedColor: theme.colors.colorSecondary,
    tabsUnselectedColor: theme.colors.colorPrimary,
    podiumUserTextcolor: 'white',
    podiumUserPointsTextcolor: theme.colors.colorSecondary,
    rankingPositionTextColor: '#6890F6',
    rankingUserTextColor: theme.colors.textPrimary,
    rankingPointsBorderColor: theme.colors.lightGray,
    linearGradientEnd: theme.colors.linearGradientEnd,
    linearGradientStart: theme.colors.linearGradientStart,
    triviaCardTextColor: 'white',
    triviaGameNextButtonBackgroundColor: theme.colors.colorSecondary,
}

//Store KPI Indicator
export const StoreKPIIndicatorTheme = {
    progressUnfilledCollor: theme.colors.colorTertiary,
    progressFilledColor: 'white',
}

export const RouletteComponentTheme = {
    centerStop0color: '#FFDE39',
    centerStop23Color: '#FFFFFF',
    centerStop43Color: '#F7B307',
    centerStop70Color: '#C7930D',
    centerStop100Color: '#F9DF9C',
}

export const ProfileDividerTheme = {
    shadowColors: ['#FAFAFA', '#BEB9CB'],
    color: '#DADADA',
}

export const CampaingViewRelevGradient = /** @type {const} */ (['#7f7af9', theme.colors.linearGradientGreenStart])

// Shimmer global theme
export const ShimmerTheme = {
    duration: 1100,
    baseColor: '#EDEFF2',
    highlightColor: '#F9FBFD',
}
